import { HttpHeaders } from '@angular/common/http';

export const WillHandleErrorMessagingHeaderName = 'WillHandleErrorMessaging';

export const WillHandleErrorMessagingHeader = new HttpHeaders({ WillHandleErrorMessaging: 'true' });

export const WillHandleErrorMessagingOption = {
  headers: WillHandleErrorMessagingHeader,
};

export const RetryHeaderName = 'Retry';

export const RetryHeader = new HttpHeaders({ Retry: 'true' });

export const RetryOption = {
  headers: RetryHeader,
};

export const CombineOptions = (optionsList: { headers: HttpHeaders }[]) => {
  const deconstructedHeaders = {};
  const deconstructHeaderOptions = optionHeaders => {
    optionHeaders.keys().forEach(key => (deconstructedHeaders[key] = optionHeaders.get(key)));
  };

  optionsList.forEach(options => deconstructHeaderOptions(options.headers));

  const combinedOptions = {
    headers: new HttpHeaders(deconstructedHeaders),
  };

  return combinedOptions;
};
